class FeaturedBenefitsCarousel extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.featured-benefits__cards');
    this.dots = Array.from(this.querySelectorAll('.featured-benefits__dot'));
    if (!this.slider || this.dots.length === 0) return;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });

    this.onScroll = this.onScroll.bind(this);
    this.slider.addEventListener('scroll', this.onScroll, { passive: true });

    this.setActive(0);
  }

  cardOffset() {
    const items = this.slider.querySelectorAll('.featured-benefits__card');
    if (items.length < 2) return 0;
    return items[1].offsetLeft - items[0].offsetLeft;
  }

  goTo(index) {
    const items = this.slider.querySelectorAll('.featured-benefits__card');
    if (!items[index]) return;
    this.slider.scrollTo({ left: items[index].offsetLeft, behavior: 'smooth' });
  }

  onScroll() {
    const offset = this.cardOffset();
    if (offset === 0) return;
    const idx = Math.round(this.slider.scrollLeft / offset);
    this.setActive(idx);
  }

  setActive(index) {
    this.dots.forEach((dot, i) => {
      const isActive = i === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

customElements.define('featured-benefits-carousel', FeaturedBenefitsCarousel);
